import React, { useState, useEffect, useRef } from "react";
import { TalkToExpertModal } from "./modal/TalkToExpertModal";
import { StickyBottomTalkToExpertBanner } from "./stickyBottomTalkToExpertBanner/StickyBottomTalkToExpertBanner";
import { useWebEngageMutation } from "../../store/ApiMutaion";
import { useCheckCertificateStatusMutation } from "../../store/ApiMutaion";
import { useExamStatusMutation } from "../../store/ApiMutaion";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useSelector } from "react-redux";
import line from "../../assets/svg/reportspage/Line24.svg";
import ProgressBar from "../../pages/components/ProgressBar";
import certific from "../../assets/svg/reportspage/certificateicon.svg";
import vector from "../../assets/svg/reportspage/Vector.svg";
import best from "../../assets/svg/reportspage/bestSub.svg";
import imporve from "../../assets/svg/reportspage/improveSub.svg";
import CircleProgressBar from "../../pages/components/circleProgressBar";
import leftArrow from "../../assets/svg/reportspage/LeftArrow.svg";
import back from "../../assets/svg/reportspage/leftarow.svg";
import { ROUTES } from "../../constants/routes";
import { CONFIG_VARS } from "../../constants/configuration";
import { format, parseISO } from "date-fns";
import { ExamConfigHelper } from "../../constants/examConfig";
import loader from "../../assets/gif/ReportsLoaderGif.gif";
import ScholarshipBanner from "./SESBanner/ScholarshipBanner";
import { getRegistrationPayload, getUserInfo } from "../../store/auth/selectors";
import { useAnalytics } from "../../contexts/AnalyticsContext";
import { trackReportPageViewed } from "../../webengage/webengageService";

const BasicReport = ({
  reportData,
  access_token,
  progressordata,
  examDetails,
  formetDate,
  examdetailes,
  timeLeft24,
  showBuyReportBanner,
  reportConfig,
  reportLoader,
  stickyBannerConfig = null,
  onStickyBannerCta = null,
  webEngageSubmittedAt
}) => {
  const [webEngage] = useWebEngageMutation();
  const [checkCertificateStatus] = useCheckCertificateStatusMutation();
  const history = useHistory();
  const [showTalkExpert, setShowTalkExpert] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [reportAvailabilityTimeLeft, setReportAvailabilityTimeLeft] = useState(null);
  const [hasTrackedResultsView, setHasTrackedResultsView] = useState(false);
  const [showCertificatePopup, setShowCertificatePopup] = useState(false);
  const [isCheckingCertificate, setIsCheckingCertificate] = useState(false);
  const registrationPayload = useSelector(getRegistrationPayload);
  const userDetails = useSelector(getUserInfo);
  const registerdExam = registrationPayload?.student_response[0]?.answer;
  const analytics = useAnalytics();

  const stuckStartTimeRef = useRef(null);
  const webEngageTriggeredRef = useRef(false);

  const shouldShowTestCompleted = ExamConfigHelper.shouldShowTestCompleted(examdetailes?.title);
  const shouldShowDownloadCertificate = ExamConfigHelper.shouldShowDownloadCertificate(examdetailes?.title);
  const shouldShowSubjectPerformance = ExamConfigHelper.shouldShowSubjectPerformance(examdetailes?.title);
  const shouldShowViewSolutions = ExamConfigHelper.shouldShowViewSolutions(examdetailes?.title);
  const shouldShowSesBanner = ExamConfigHelper.shouldShowSesBanner(examdetailes?.title);
  const shouldShowTalkToExpert = ExamConfigHelper.shouldShowTalkToExpert(examdetailes?.title);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    if (!reportLoader && !hasTrackedResultsView && reportData?.marks_obtained !== undefined) {
      const timeSpent = reportData?.time_spent_minutes || 0;
      const timeSpentSeconds = typeof timeSpent === "string" ? parseInt(timeSpent) * 60 : timeSpent * 60;

      analytics.trackResultsPageViewed(examdetailes?.exam_id, timeSpentSeconds);
      setHasTrackedResultsView(true);
    }
  }, [reportLoader, reportData, examdetailes?.exam_id, hasTrackedResultsView, analytics]);

  // WebEngage tracking using the prop from parent
  useEffect(() => {
    // Don't trigger if already triggered, report still loading, or missing data
    if (webEngageTriggeredRef.current || reportLoader || !webEngageSubmittedAt || !reportData) {
      return;
    }

    try {
      console.log("[WebEngage] Processing submitted_at from parent:", webEngageSubmittedAt);

      const submittedTime = parseISO(webEngageSubmittedAt);
      const currentTime = new Date();
      const timeDifferenceMinutes = (currentTime - submittedTime) / (1000 * 60);

      console.log(`[WebEngage] Time since submission: ${timeDifferenceMinutes.toFixed(2)} minutes`);

      // Only trigger if within 5 minutes of submission
      if (timeDifferenceMinutes <= 5) {
        const examName = examdetailes?.title;

        if (examName && reportData) {
          webEngageTriggeredRef.current = true;
          trackReportPageViewed(examName, userDetails, reportData, examdetailes);
          console.log(
            `[WebEngage] ✓ Report_page_viewed triggered for ${examName} (${timeDifferenceMinutes.toFixed(
              2
            )} minutes after submission)`
          );
        } else {
          console.log("[WebEngage] ✗ Cannot trigger - missing examName or reportData");
        }
      } else {
        console.log(
          `[WebEngage] ✗ Not triggering - ${timeDifferenceMinutes.toFixed(2)} minutes exceeds 5 minute limit`
        );
      }
    } catch (error) {
      console.error("[WebEngage] Error processing submitted_at:", error);
    }
  }, [reportLoader, webEngageSubmittedAt, reportData, examdetailes?.title, userDetails, examdetailes]);

  useEffect(() => {
    if (!reportLoader) {
      setReportAvailabilityTimeLeft(null);
      return undefined;
    }

    const examStartedAt = examdetailes?.examStartedAt;
    const examDurationInMinutes = Number(examdetailes?.examDurationInMinutes);

    if (!examStartedAt || !Number.isFinite(examDurationInMinutes)) {
      setReportAvailabilityTimeLeft(null);
      return undefined;
    }

    const normalizedStart = examStartedAt.trim().replace(" ", "T");
    const utcStartString = normalizedStart.endsWith("Z") ? normalizedStart : `${normalizedStart}Z`;
    const examStartTime = new Date(utcStartString);

    if (Number.isNaN(examStartTime.getTime())) {
      setReportAvailabilityTimeLeft(null);
      return undefined;
    }

    const reportReadyAtMs = examStartTime.getTime() + (examDurationInMinutes + 300) * 60 * 1000;
    const getRemainingSeconds = () => Math.max(Math.floor((reportReadyAtMs - Date.now()) / 1000), 0);

    setReportAvailabilityTimeLeft(getRemainingSeconds());

    const intervalId = setInterval(() => {
      setReportAvailabilityTimeLeft(getRemainingSeconds());
    }, 1000);

    return () => clearInterval(intervalId);
  }, [reportLoader, examdetailes?.examStartedAt, examdetailes?.examDurationInMinutes]);

  useEffect(() => {
    if (reportLoader) {
      stuckStartTimeRef.current = Date.now();
    } else {
      stuckStartTimeRef.current = null;
    }
  }, [reportLoader]);

  useEffect(() => {
    return () => {
      if (stuckStartTimeRef.current !== null) {
        const timeSpentMs = Date.now() - stuckStartTimeRef.current;
        const loadTimeSecs = Math.floor(timeSpentMs / 1000);
        if (loadTimeSecs >= 1) {
          analytics.trackReportStuckLoading(loadTimeSecs, timeSpentMs);
        }
        stuckStartTimeRef.current = null;
      }
    };
  }, [analytics]);

  const formatReportWaitTime = (seconds) => {
    const safeSeconds = Math.max(Number(seconds) || 0, 0);
    const hours = Math.floor(safeSeconds / 3600);
    const minutes = Math.floor((safeSeconds % 3600) / 60);
    const remainingSeconds = safeSeconds % 60;

    return `${String(hours).padStart(2, "0")}h:${String(minutes).padStart(2, "0")}m:${String(remainingSeconds).padStart(
      2,
      "0"
    )}s`;
  };

  const hasReportAvailabilityTimer = reportAvailabilityTimeLeft !== null;

  const getDisplayExamName = (examName) => {
    if (!examName) return "";

    if (examName.toLowerCase() === "youth entrepreneurship challenge" && isMobile) {
      return "YEC";
    }
    if (examName.toLowerCase() === "score edge scholarship test" && isMobile) {
      return "SES Test";
    }

    return examName;
  };

  const handleBannerClick = () => {
    setShowTalkExpert(true);
  };

  const handleCloseTalkExpert = () => {
    setShowTalkExpert(false);
  };

  const handleBackButtonClick = () => {
    history.push(ROUTES.DASHBOARD);
  };

  const handleDownloadCertificet = async () => {
    const score = reportData?.marks_obtained || 0;
    analytics.trackCertificateDownloadClicked(examdetailes?.exam_id, score);

    if (examdetailes?.certificate_link) {
      const url = `${CONFIG_VARS.certficateUrl}/${examdetailes.crn_id}/${examdetailes.event_id}.pdf`;
      window.open(url, "_blank");
      return;
    }

    setIsCheckingCertificate(true);

    try {
      const result = await checkCertificateStatus({
        event_id: examdetailes?.event_id
      }).unwrap();

      if (result?.has_certificate === true && result?.certificate_url) {
        window.open(result.certificate_url, "_blank");
      } else {
        setShowCertificatePopup(true);
      }
    } catch (error) {
      let errorDetail = null;

      if (error?.data?.detail) {
        errorDetail = error.data.detail;
      } else if (error?.response?.data?.detail) {
        errorDetail = error.response.data.detail;
      } else if (error?.error?.data?.detail) {
        errorDetail = error.error.data.detail;
      } else if (typeof error === "object" && error.detail) {
        errorDetail = error.detail;
      }

      if (errorDetail === "data not found") {
        setShowCertificatePopup(true);
      } else {
        setShowCertificatePopup(true);
      }
    } finally {
      setIsCheckingCertificate(false);
    }
  };

  const handleCloseCertificatePopup = () => {
    setShowCertificatePopup(false);
  };

  const handleViewSolutions = async () => {
    analytics.trackViewSolutionsClicked(examdetailes?.exam_id);
    const baseUrl = `${CONFIG_VARS.scoreViewreportUrl}/test/viewsolutionspage?test_type=e34d1d14-6c33-48fd-900e-e8d3cb76da64`;
    const examId = examdetailes.exam_id;
    const qu_id = examdetailes.qu_id;
    const token = access_token.replace("Bearer ", "");
    const url = `${baseUrl}&question_paper_id=${qu_id}&token=${token}&exam_id=${examId}&is_from=genius`;
    window.open(url, "_self", "noreferrer");
  };

  return (
    <div>
      {showCertificatePopup && (
        <div className="certificate-popup-overlay">
          <div className="certificate-popup">
            <button className="certificate-popup-close" onClick={handleCloseCertificatePopup}>
              ×
            </button>
            <div className="certificate-popup-content">
              <div className="certificate-popup-icon">
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M32 58C46.3594 58 58 46.3594 58 32C58 17.6406 46.3594 6 32 6C17.6406 6 6 17.6406 6 32C6 46.3594 17.6406 58 32 58Z"
                    stroke="#FFB800"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path d="M32 22V34" stroke="#FFB800" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path
                    d="M32 42H32.02"
                    stroke="#FFB800"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <h3 className="certificate-popup-title">Hang tight! Your certificate is on its way.</h3>
              <p className="certificate-popup-message">
                We're processing it and it will be available soon. Please check back shortly or revisit this page later.
              </p>
              <button onClick={handleCloseCertificatePopup} className="certificate-popup-button">
                Got it
              </button>
            </div>
          </div>
        </div>
      )}

      {shouldShowTalkToExpert && <TalkToExpertModal isOpen={showTalkExpert} onClose={handleCloseTalkExpert} />}

      <div className="Rep_btn-cont">
        <button onClick={handleBackButtonClick} className="Rep_back-btn">
          <span>
            <img src={back} alt="Back" />
          </span>
          back
        </button>
        <div className="Rep_back-btn2">
          <div className="Rep_back-btn2In">
            {" "}
            <img onClick={handleBackButtonClick} src={leftArrow} alt="Back" /> <p>Report</p>
          </div>
        </div>
        {shouldShowViewSolutions && !reportLoader && (
          <button onClick={handleViewSolutions} className="attempt-btn Rep_attempt-btn1">
            View Solutions
          </button>
        )}
      </div>
      <div className="rep-whole-cont" style={{ marginTop: "20px" }}>
        {!reportLoader ? (
          <div style={{ flex: 1 }}>
            <h1 className="Rep_exam-title">
              {getDisplayExamName(examdetailes?.title)}{" "}
              {["semi-finals", "finals"].includes(examdetailes.level?.toLowerCase()) ? "" : examdetailes.level} |{" "}
              {examdetailes?.event_type?.toLowerCase() === "offline"
                ? format(parseISO(examdetailes?.event_date), "dd MMMM yyyy")
                : formetDate}{" "}
            </h1>

            {shouldShowTestCompleted && shouldShowDownloadCertificate && (
              <div className="cetrificate-cont">
                <div className="Rep-text-cont">
                  <img src={certific} alt="note" className="mock_img mock_imgweb" />
                  <div className="Rep_mock-Cont">
                    <h2 className="mock-text Rep_mock-text">Test Completed</h2>
                    <p className="mock-para Rep_mock-para ">
                      Celebrate your achievement! Download your certificate now.
                    </p>
                  </div>
                  <img src={certific} alt="note" className="mock_img mock_imgmob" />
                </div>
                <button
                  onClick={handleDownloadCertificet}
                  className="attempt-btn Rep_attempt-btn2"
                  disabled={isCheckingCertificate}
                >
                  {isCheckingCertificate ? "Checking..." : "Download Certificate"}
                </button>
              </div>
            )}

            <h3 className="Rep_sub-head" id="tte-report-overview">
              Overview
            </h3>
            <div className="Rep_card-cont">
              <div className="Rep_score_card">
                <img src={vector} alt="vector" className="rep_card_vector" />
                <div>
                  <h4 className="Rep_score_cardHead">Score</h4>
                  <p>
                    {reportData?.marks_obtained}
                    <span>/{reportData?.maximum_marks} marks</span>
                  </p>
                </div>
                <img className="Rep_score_cardLine" src={line} alt="divider" />
                <div className="Rep_score_cardButtom">
                  <div>
                    <h4 className="Rep_score_cardHead">Accuracy</h4>
                    <p className="Rep_score_cardDes">{reportData?.accuracy}%</p>
                  </div>
                  {examdetailes?.event_type !== "OFFLINE" && (
                    <div>
                      <h4 className="Rep_score_cardHead">Time Taken</h4>
                      <p>{reportData?.time_spent_minutes}</p>
                    </div>
                  )}
                  <div>
                    <h4 className="Rep_score_cardHead">Total Time</h4>
                    <p>{reportData?.exam_duration_in_minutes} M</p>
                  </div>
                </div>
              </div>
              <CircleProgressBar
                totalMarks={reportData?.total_questions}
                correctMarks={reportData?.correct_answers}
                incorrectMarks={reportData?.incorrect_answers}
                unattempted={reportData?.unattempted_questions}
              />{" "}
            </div>
            {shouldShowSesBanner && (
              <ScholarshipBanner
                grade={examdetailes?.grade_id}
                examType={registerdExam && registerdExam !== "" ? registerdExam : examdetailes?.StudentExamType}
                totalMarks={reportData?.maximum_marks}
                marksObtained={reportData?.marks_obtained}
              />
            )}

            {shouldShowSubjectPerformance && (
              <>
                <h3 className="Rep_sub-head" id="tte-report-subject-performance">
                  Subject Performance
                </h3>
                <div className="perform_box">
                  <div>
                    <div className="perform_webflex">
                      <div>
                        <figure className="mb-0">
                          <img src={best} alt="subone" />
                        </figure>
                      </div>
                      <div className="perform_mobflex">
                        <h3 className="SCRPT-icnhdng no_mb">Best subject</h3>
                        <h4 className="SCRPT-cunt SCRPT-elips">
                          {reportData?.subject_performance?.highest?.section_name}
                        </h4>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="perform_webflex">
                      <div>
                        <figure className="mb-0">
                          <img src={imporve} alt="subtwo" />
                        </figure>
                      </div>
                      <div className="perform_mobflex">
                        <h3 className="SCRPT-icnhdng no_mb">Scope of improvement</h3>
                        <h4 className="SCRPT-cunt SCRPT-elips">
                          {reportData?.subject_performance?.lowest?.section_name}
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            <div className="Rep_Sub_cont">
              <h3 className="Rep_graph_cardHead">Sectionwise Score</h3>
              <div className="Rep_Sub_contIn">
                {Object.keys(progressordata).map((subject) => (
                  <div key={subject} className="Rep_Sub_cont-card">
                    <h3 className="Rep_Sub_contSubject">{subject}</h3>
                    <div className="Rep_progressor-cont">
                      <ProgressBar
                        progress={progressordata[subject]?.marks_obtained}
                        total={progressordata[subject]?.total_marks}
                      />
                      <p>
                        {progressordata[subject]?.marks_obtained}/{progressordata[subject]?.total_marks}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          <div className="ReportLoaderCont">
            <img className="Reploader" src={loader} alt="Loading..." />
            <h3 className="ReportLoaderMSG">
              <span>Thank you for completing the test!</span>
              <br />
              Your submission has been recorded successfully. Your <span>detailed report and certificate</span> are
              currently being generated.
              {hasReportAvailabilityTimer && (
                <>
                  <br />
                  Please check back after{" "}
                  <span style={{ fontSize: "14px" }} className="Rep_timer-time">
                    {formatReportWaitTime(reportAvailabilityTimeLeft)}
                  </span>{" "}
                  to access them.
                </>
              )}
            </h3>
          </div>
        )}
      </div>
      {examdetailes?.title?.toLowerCase().includes("score") && !reportLoader && (
        <h3 className="Rep_sub-head">Section-wise breakdown</h3>
      )}

      {shouldShowTalkToExpert && stickyBannerConfig && !reportLoader && (
        <StickyBottomTalkToExpertBanner
          config={stickyBannerConfig}
          visible={shouldShowTalkToExpert && !reportLoader}
          examTitle={examdetailes?.title}
          reportData={reportData}
          progressordata={progressordata}
          onCtaClick={onStickyBannerCta ?? handleBannerClick}
        />
      )}
    </div>
  );
};

export default BasicReport;
